import TermsAndConditionsPage from "@/interface/components/settings/terms-and-conditions/terms-and-conditions-page";
import { MainLayout } from "@/interface/components/layout/main-layout";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/terms-and-conditions")(
  {
    component: RouteComponent,
  }
);

function RouteComponent() {
  const navigate = useNavigate();

  function handleClose() {
    navigate({ to: "/users/settings", replace: true });
  }

  return (
    <MainLayout title="Términos y Condiciones">
      <main className="flex h-full flex-col items-stretch">
        <section
          className={cn(
            "flex flex-1 flex-col items-stretch gap-6 p-6",
            "sm:w-[640px] sm:self-center",
            "lg:w-auto lg:max-w-4xl lg:self-center lg:px-8 lg:py-8"
          )}>
          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 shadow-sm lg:p-10 lg:shadow-md">
            <TermsAndConditionsPage onClose={handleClose} />
          </div>
        </section>
      </main>
    </MainLayout>
  );
}
